import script from "./goRinSyo0047.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0047.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0047.vue?vue&type=style&index=0&id=f2c955ce&lang=scss"

const __exports__ = script;

export default __exports__